import { cn } from '@/components/ui'

/**
 * The one line every screen ends on — signed in or not.
 *
 * A real link, not a styled span: `Gonav.tech` opens the company's own site in
 * a new tab, `target="_blank"` paired with `rel="noopener noreferrer"` the same
 * way `AppShell`'s `EXTERNAL_LINKS` open theirs, so a page this application does
 * not itself render never inherits a handle on `window.opener`.
 *
 * The year is read from the browser's own clock at render time rather than
 * written as a literal, so the footer does not go stale on every January 1st a
 * deploy does not happen to land on.
 */
export function CopyrightFooter({ className }: { className?: string }) {
  const year = new Date().getFullYear()

  return (
    <footer className={cn('py-6 text-center text-micro text-muted', className)}>
      © {year}{' '}
      <a
        href="https://gonav.tech"
        target="_blank"
        rel="noopener noreferrer"
        className="text-muted underline decoration-divider underline-offset-2 hover:text-ink"
      >
        Govind Kedia — Gonav.tech
      </a>
    </footer>
  )
}
